import { css } from '@emotion/css'

export const container = css`
  background-color: #FCFCFC;
  min-height: 100vh;

  @media screen and (min-width: 912px) {
    display: flex;
  }
`

export const fractalContainer = css`
  text-align: center;
  padding: 3em;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 912px) {
    order: 1;
    width: 45%;
    display:flex;
    justify-content:space-evenly
  }
`

export const childContainer = css`
  padding: 2em;
  flex: 1;

  @media screen and (min-width: 912px) {
    order: 0;
  }
`
